import styles from './StatsBar.module.scss';
import { useSelector } from 'react-redux';
import { selectScenarioTwoStats } from 'selectors/selectors';
import {
    checkNullReturnZero,
    formatNumber2DPStringIfNotZeroOrHundred,
    numberFormat
} from 'utils/common';

const ScenarioTwoStats = () => {
    const scenarioTwoStats = useSelector(selectScenarioTwoStats);
    const {
        totalConcentration,
        percentConcentration,
        totalPortfolio,
        percentPortfolio,
        totalOutliers,
        percentOutliers
    } = { ...scenarioTwoStats };
    return (
        <>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(
                            numberFormat(totalConcentration, true)
                        )}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            percentConcentration
                        )}
                    </div>
                </div>
                <div className={styles.description}>
                    Concentration Risk Alerts
                </div>
            </div>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(
                            numberFormat(totalPortfolio, true)
                        )}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            percentPortfolio
                        )}
                    </div>
                </div>
                <div className={styles.description}>
                    Portfolio Risk Mismatch Alerts
                </div>
            </div>
            <div className={styles.stat}>
                <div className={styles.value}>
                    <div className={styles.main}>
                        {checkNullReturnZero(totalOutliers)}
                    </div>
                    <div className={styles.percentage}>
                        {formatNumber2DPStringIfNotZeroOrHundred(
                            percentOutliers
                        )}
                    </div>
                </div>
                <div className={styles.description}>S2 Outliers</div>
            </div>
        </>
    );
};

export default ScenarioTwoStats;
